<template>
  <v-dialog scrollable width="800px" v-model="showDialog">
    <v-card height="550px">
      <v-card-title>
        <h4>Detalle: {{ grupo }}</h4>
      </v-card-title>
      <v-card-text>
        <v-data-table
          ref="html2Pdf"
          :items="items"
          :headers="headers"
          dense
          :loading="loading"
          id="tabla"
        >
          <template v-slot:[`item.fechaAlta`]="props">
            {{ props.item.fechaAlta | formatDate }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn @click="descargar">DESCARGAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';

export default {
  props: ["grupo"],
  data() {
    return {
      loading: false,
      showDialog: true,
      items: [],
      headers: [
        { text: "Cedula", value: "cedula" },
        { text: "Nombres", value: "nombres" },
        { text: "Fecha Asistencia", value: "fechaAlta" },
      ],
    };
  },
  mounted() {
    this.cargar();
  },

  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
    },
  },
  methods: {
    formatDateMethod(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
      return "";
    },
    
    // close() {
    //   // this.showDialog = false;
    //   this.$emit('close');
    // },
    async descargar() {
      // let pdfName = "test";
      // var doc = new jsPDF();
      // doc.text("Hello World", 10, 10);
      // doc.save(pdfName + ".pdf");

      let ii = 0;
      const items = this.items.map(i => {
        ii++;
        return [ii, i.cedula, i.nombres, i.fechaAlta ? moment(String(i.fechaAlta)).format("DD/MM/YYYY hh:mm") : '']
      })

      console.log('*****', items)

      const doc = new jsPDF();
      doc.text("GRUPO: " + this.grupo, 15, 10);
      doc.text("Fecha: " + moment(new Date()).format("DD/MM/YYYY hh:mm"), 110, 10);
      autoTable(doc, {
        head: [["Nro. ","Cedula", "Nombres", "Fecha Asistencia"]],
        body: items,
      });

      const lastTablePos = doc.autoTable.previous.finalY;

      doc.text("Presentes: " + this.items.filter(r => r.fechaAlta !== null).length,15,lastTablePos + 10);

      doc.save(this.grupo+".pdf");
    },
    volver() {
      this.$emit("close");
      this.showDialog = false;
    },
    cargar() {
      this.loading = true;
      axios
        .get(`/eventoSocial/detalleGrupo?grupo=${this.grupo}`)
        .then((response) => {
          this.loading = false;
          this.items = response.data;
          console.log(response);
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
  },
};
</script>